import HeroIconStarting from "./HeroIconStarting";
import "./hero-icon-starting.scss";

export default HeroIconStarting;
